import { render, staticRenderFns } from "./activity-completion-metrics.vue?vue&type=template&id=982aade0&"
import script from "./activity-completion-metrics.vue?vue&type=script&lang=js&"
export * from "./activity-completion-metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "activity-completion-metrics.vue"
export default component.exports